













	import { Vue, Component, Prop } from "../../Infrastructure/CorBase/CoreBase";


	@Component
	export default class BaseTLLabel extends Vue {
		@Prop({ type: String, required: true, default: "" }) label?: string; //hlavní popis
		@Prop({ type: String, required: false, default: "6" }) labelWidth?: string; //šířka
		@Prop({ type: Boolean, required: false, default: false }) isBig?: boolean; //větší pismo
		@Prop({ type: Boolean, required: false, default: false }) isColoredFont?: boolean; //barevne písmo
        @Prop({ type: Boolean, required: false, default: false }) showUpDownIcon?: boolean; //zobrazovani sipek nahoru a dolu (pro schovavani podslozek)
        @Prop({ type: Boolean, required: false, default: false }) showUp?: boolean; //zobrazeni sikpy nahoru (nefunguje bez showUpDownIcon)
		@Prop({ type: String, required: false, default: "" }) forinput?: string; //pro koho je to popisek
		@Prop({ type: String, required: false, default: "sm" }) size?: string; //velikost pisma sm, lg
		@Prop({ type: String, required: false, default: "left" }) align?: string; //zarovnání 
		@Prop({ type: String, required: false, default: "2" }) labelcols?: string; //počet řádků - velikost 
	
		//načtení stylu
		get inputClass() {
			return {
				"colored-font": this.isColoredFont == true,
				"label-design-head": false,//puvodni
				"labelDetailForm": true,
				"label-design-head-bigger": this.isBig == true
			};
		}

		clickUp(isUp: boolean) {
            this.$emit('clickUp', isUp);
		}
	}
